import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';

import playbookEditEntryPoint from '@jira/spa-apps__project-settings-playbooks-edit-view/src/playbookEditViewEntryPoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskPlaybooksEditDedicatedRoute } from '@jira/router-routes__project-settings-playbooks-routes/src/servicedeskPlaybooksEditDedicatedRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { PlaybookEditSkeleton } from '@jira/playbooks__edit-screen/src/PlaybookEditSkeleton.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const editEntryPoint = createPageEntryPoint({
	main: playbookEditEntryPoint,
});

export const servicedeskPlaybooksEditDedicatedRouteEntry: Route = createEntry(
	servicedeskPlaybooksEditDedicatedRoute,
	() => ({
		group: 'project-settings-servicedesk',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		entryPoint() {
			// AEM's isFeatureEnabled is the source of truth for Playbooks availability (it already
			// encodes the FedRamp / isolated-cloud restrictions), replacing the deprecated isFedRamp.
			if (!isFeatureEnabled('jira-service-management', 'jsm-automation-playbook')) {
				return notFoundPageEntrypoint;
			}
			// This dedicated `/edit/:playbookId` route only serves the edit screen behind the
			// migration gate; with the gate off the legacy `/:playbookId` route serves it instead.
			if (!fg('playbooks_edit_route_migration')) {
				return notFoundPageEntrypoint;
			}
			return editEntryPoint;
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],

		// Mirrors the legacy edit route's reporting id and ufoName so edit metrics stay continuous
		// across the migration.
		meta: {
			reporting: {
				id: 'project-settings.playbooks.admin-edit-view',
				packageName: camelCase('project-settings-playbooks-edit'),
				teamName: 'ITOps Phantom',
			},
		},

		ufoName: 'playbook-edit',
		skeleton: PlaybookEditSkeleton,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
